import type { StatsScale, StatsSeriesResponse, StatsSummary } from "@shared";
import { apiFetch, apiPost } from "../api/client";

/** Appels de la page de statistiques. Session distincte de celle de l'admin. */

export const statsSession = () => apiFetch<{ stats: boolean }>("/stats/me");
export const statsLogin = (password: string) =>
  apiPost<{ stats: boolean }>("/stats/login", { password });
export const statsLogout = () => apiPost<{ stats: boolean }>("/stats/logout");

export const fetchSeries = (scale: StatsScale) =>
  apiFetch<StatsSeriesResponse>(`/stats/series?scale=${scale}`);

export const fetchSummary = () => apiFetch<StatsSummary>("/stats/summary");

/** mm:ss — le même format que le chronomètre montré au jeune. */
export function formatDuree(secondes: number): string {
  const m = Math.floor(secondes / 60);
  const s = secondes % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/**
 * Étiquette d'un intervalle, selon l'échelle.
 *
 * En heure et en jour on affiche l'heure LOCALE : l'organisateur raisonne sur
 * l'heure de la fête, pas sur UTC. Le stockage, lui, reste en UTC partout.
 */
export function formatBucket(bucket: string, scale: StatsScale): string {
  const d = new Date(bucket);
  if (scale === "hour") {
    return d.toLocaleTimeString("fr-CA", { hour: "2-digit", minute: "2-digit" });
  }
  if (scale === "day") {
    return d.toLocaleDateString("fr-CA", { month: "short", day: "numeric" });
  }
  if (scale === "month") {
    return d.toLocaleDateString("fr-CA", { month: "short", year: "numeric" });
  }
  return `sem. ${d.toLocaleDateString("fr-CA", { month: "short", day: "numeric" })}`;
}
